module.exports = __webpack_public_path__ + "img/icon_map_32_on_101.ff34d397.png";